import Analitics from '../Components/Charts/Analitics';
import AddContact from '../pages/Contacts/AddContact/addContact';
import Contacts from '../pages/Contacts/contacts';
import Kyc from '../pages/kyc/kyc';
import Licenses from '../pages/Licenses/licenses';
import LicensesHistory from '../pages/Licenses/LicensesHistory/licensesHistory';
import ClientRole from '../Model/clientRole';
import RouteModel from '../Model/routeModel';
import AddSensors from '../pages/Sensors/AddSensors/addSensors';
import Sensors from '../pages/Sensors/sensors';
import SensorsOwners from '../pages/Sensors/sensorsOwners';
import TempSensors from '../pages/Sensors/tempSensors';
import ChangeAccount from '../pages/Support/ChangeAccount/changeAccount';
import Clawback from '../pages/Support/Clawback/clawback';
import MergeAccount from '../pages/Support/MergeAccount/mergeAccount';
import NftMove from '../pages/Support/NftMove/nftMove';
import walletsList from '../pages/Wallets/walletsList';
import CheckNft from '../pages/b2b/CheckNft';
import SensorsTesting from '../pages/Sensors/SensorsTesting/SensorsTesting';
import AwairSensorsList from '../pages/AwairSensorsList/AwairSensorsList';
import Dashboard from '../pages/Dashboard/dashboard';
import billingCodesGenerator from '../pages/purchases/billingCodesGenerator';
import Payments from '../Components/Purchases/Payments/Payments';
import transactionsList from '../pages/purchases/transactionsList';
import OrderForm from '../pages/purchases/OrderForm';
import PurchasesList from '../pages/purchases/PurchasesList';

export const routeHome: RouteModel = {
  path: '/',
  component: Dashboard,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};

export const routeAnalitics: RouteModel = {
  path: '/analitics',
  component: Analitics,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};

export const routeB2B: RouteModel = {
  path: '/b2b/check-nft',
  component: CheckNft,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};
export const routeAddSensor: RouteModel = {
  path: '/add',
  component: AddSensors,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};
export const routeSensors: RouteModel = {
  path: '/sensors',
  component: Sensors,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};
export const routeTempSensors: RouteModel = {
  path: '/tempSensors',
  component: TempSensors,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};
export const routeContacts: RouteModel = {
  path: '/contacts',
  component: Contacts,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};
export const routeAddContact: RouteModel = {
  path: '/addContacts',
  component: AddContact,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};
export const routeOwners: RouteModel = {
  path: '/owners',
  component: SensorsOwners,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};
export const routeKyc: RouteModel = {
  path: '/kyc',
  component: Kyc,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};
export const routePurchases: RouteModel = {
  path: '/purchases',
  component: PurchasesList,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};

export const routePayments: RouteModel = {
  path: '/orders/:orderId/payments',
  component: Payments,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};

// export const routeAddPayments: RouteModel = {
//   path: '/orders/:orderId/payments/0',
//   component: PaymentsForm,
//   forRealm: false,
//   roles: [ClientRole.ADMIN]
// };

// export const routeEditPayments: RouteModel = {
//   path: '/orders/:orderId/payments/:paymentId',
//   component: PaymentsForm,
//   forRealm: false,
//   roles: [ClientRole.ADMIN]
// };

export const routeAddPurchase: RouteModel = {
  path: '/purchases/0',
  component: OrderForm,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};
export const routePurchase: RouteModel = {
  path: '/purchases/:id',
  component: OrderForm,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};
export const routeLicenses: RouteModel = {
  path: '/licenses',
  component: Licenses,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};
export const routeLicensesHistory: RouteModel = {
  path: '/licenses/history',
  component: LicensesHistory,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};
export const routeChangeAccount: RouteModel = {
  path: '/changeAccount',
  component: ChangeAccount,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};
export const routeNftMove: RouteModel = {
  path: '/nftMove',
  component: NftMove,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};
export const routeClawback: RouteModel = {
  path: '/clawback',
  component: Clawback,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};
export const transactions: RouteModel = {
  path: '/transactions',
  component: transactionsList,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};
export const routeMergeAccount: RouteModel = {
  path: '/mergeAccount',
  component: MergeAccount,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};
export const routeWalletsList: RouteModel = {
  path: '/wallets',
  component: walletsList,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};
export const routeGenerationBillingCodes: RouteModel = {
  path: '/orders/generation',
  component: billingCodesGenerator,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};
export const routeSensorsTesting: RouteModel = {
  path: '/sensors/:type/testing',
  component: SensorsTesting,
  forRealm: false,
  roles: [ClientRole.AIRQINO]
};
export const routeAirquino: RouteModel = {
  path: '/sensors/:type/testing',
  component: SensorsTesting,
  forRealm: false,
  roles: [ClientRole.AIRQINO]
};
export const awairRefundVoucherList: RouteModel = {
  path: '/sensors/awair/refunds-coupons',
  component: AwairSensorsList,
  forRealm: false,
  roles: [ClientRole.ADMIN]
};

const routes: RouteModel[] = [
  routeAirquino,
  routeHome,
  routeAddSensor,
  routeSensors,
  routeTempSensors,
  routeContacts,
  routeAddContact,
  routeOwners,
  routeKyc,
  routePurchases,
  routeAddPurchase,
  routePurchase,
  routeLicenses,
  routeChangeAccount,
  routeNftMove,
  routeClawback,
  transactions,
  routeLicensesHistory,
  routeMergeAccount,
  routeWalletsList,
  routeGenerationBillingCodes,
  routeAnalitics,
  routeB2B,
  routePayments,
  routeSensorsTesting,
  awairRefundVoucherList
];

export default routes;